import { render, staticRenderFns } from "./promotion_form_create.vue?vue&type=template&id=6e344cfc&"
import script from "./promotion_form_create.vue?vue&type=script&lang=js&"
export * from "./promotion_form_create.vue?vue&type=script&lang=js&"
import style0 from "./promotion_form_create.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports